import {
  Component,
  Element,
  Event,
  EventEmitter,
  forceUpdate,
  Fragment,
  getAssetPath,
  h,
  Host,
  Listen,
  Method,
  Prop,
  State,
  Watch,
} from '@stencil/core';

import wcShared from '@web-components/shared';

import { IReportingToolsUser } from '../../models/typing';
import { ReportService } from '../../services/report.service';
import commonStore from '../../stores/common.store';
import formStore from '../../stores/form.store';

@Component({
  tag: 'app-main-modal',
  styleUrl: 'main-modal.scss',
  shadow: true,
})
export class ModuleMainModal {
  @Element() private element: HTMLAppMainModalElement;

  @Event() openReportingToolWC: EventEmitter;
  @Event() emitReportSubmitted: EventEmitter<{ ticketUrl: string }>;

  @Prop() readonly doPrintScreen: boolean;
  @Prop() readonly isInitLoading: boolean;
  @Prop() readonly user: IReportingToolsUser;
  @Prop() readonly hidden: boolean;
  @Prop() readonly isAutologged: boolean;
  @Prop() readonly host: HTMLModuleReportingToolsComponentElement;

  private subjectInputRef: HTMLInputElement;

  @Watch('doPrintScreen')
  handleDoPrintScreen(newValue: boolean) {
    // This comment section is to automatically print screen
    // setTimeout(() => {
    //   if (newValue === true && formStore.files.length === 0 && !commonStore.state.isPrintingScreen && !['workspace.mail', 'internal'].includes(window['CURRENT_ROUTE'])) {
    //     this.printScreen();
    //   }
    // }, 200);
    const modulesToHide = [
      document.querySelector<HTMLElement>('module-helpdesk-component'),
      document.querySelector<HTMLElement>('app-old-manager-button'),
      document.querySelector<HTMLElement>('app-tutorial-button'),
      document.querySelector<HTMLElement>('.others-elements'),
    ];
    modulesToHide.forEach((moduleTohide) => {
      if (Boolean(moduleTohide)) {
        moduleTohide.style.visibility = newValue ? 'hidden' : 'visible';
      }
    });

    if (!newValue && !commonStore.state.isRecording) {
      this.hideModalAnimated();
    }
  }
  @State() dragOverFiles = false;
  @State() files: File[] = [];
  @State() arrayError = [];

  // ANIMATION
  @State() modalIsClosing = false;

  @State() isLoading = false;
  @State() showResultSuccess = false;
  @State() showResultError = false;
  @State() isReportOpen = false;
  @State() isFeedbackOpen = false;
  @State() ticketLink: string = null;

  // FORM
  private inputFile: HTMLInputElement;
  private subjectTitleHTMLElement: HTMLElement;
  private cerberusLinkTMLElement: HTMLElement;
  private descriptionTitleHTMLElement: HTMLElement;
  private subjectTitleFeedbackHTMLElement: HTMLElement;
  private descriptionTitleFeedackHTMLElement: HTMLElement;
  private bugPriorityHTMLElement: HTMLSelectElement;
  private shadowRoot;
  @State() isFormValid = true;
  @State() isFormValidFeedback = true;
  @State() isFeedbackForm = false;
  // RECORDING
  private videoStreamHTMLElement: HTMLMediaElement;
  private mediaRecorder: MediaRecorder;
  private cameraStream = null;
  private recordingNumber = 1;
  // PRINT SCREEN
  private screenshotNumber = 1;
  // UPLAOD FILES
  private dataFiles: File[];
  private isFirstOpened = true;
  private formTitleFocusClass = 'ik-form__title--focus';

  @Listen('keypress')
  onKeyPress(e) {
    if (!this.hidden && e.altKey && e.code === 'KeyS') {
      e.preventDefault();
      e.stopPropagation();
      this.oncheckFormAndSendReport();
    }
  }

  @Watch('hidden')
  onHiddenChange() {
    if (this.hidden) this.isFirstOpened = true;
  }

  @Watch('isInitLoading')
  onLoadingChange() {
    this.setDefaultPriority();
  }

  componentDidLoad() {
    commonStore.onChange('onRecording', (value) => {
      if (value) {
        this.startStreaming();
      } else {
        this.stopStreaming();
      }
    });
    this.updateProject();
  }

  componentDidRender() {
    this.shadowRoot = this.element.shadowRoot;
    if (!this.hidden && this.isFirstOpened && this.subjectInputRef) {
      this.isFirstOpened = false;
      this.subjectInputRef.focus();
    }
  }

  private hideModalAnimated = (): void => {
    this.modalIsClosing = true;

    const modal = this.shadowRoot.getElementById('main-modal');
    modal.style.animation = 'none';
    void modal.offsetWidth;
    modal.style.animation = '';

    setTimeout(() => {
      commonStore.state.displayModal = false;

      // Resetting the form
      // this.resetForm();
      if (this.showResultSuccess) {
        this.resetForm();
      }

      this.modalIsClosing = false;
    }, 300);
  };

  private resetForm(): void {
    formStore.description = null;
    formStore.subject = null;
    formStore.subjectFeedback = null;
    formStore.descriptionFeedback = null;
    formStore.printScreen = null;
    formStore.recordedVideo = null;
    formStore.recordedVideoFile = null;
    formStore.hasScreenshot = false;
    formStore.isScreenshotLoading = false;
    this.showResultError = false;
    this.showResultSuccess = false;
    this.ticketLink = null;
    this.isFormValid = true;
    this.isFormValidFeedback = true;
    this.screenshotNumber = 1;
    this.recordingNumber = 1;
    formStore.files = [];
    this.arrayError = [];
    this.updateTotalFileSize();
    this.shadowRoot.getElementById('form-subject').value = null;
    this.shadowRoot.getElementById('form-description').value = null;
    this.shadowRoot.getElementById('form-subject-feedback').value = null;
    this.shadowRoot.getElementById('form-description-feedback').value = null;
    this.setDefaultPriority();
    this.isReportOpen = false;
    this.isFeedbackOpen = false;
  }

  /* -------------------------------------------------------------------------- */
  /*                                PRINT SCREEN                                */
  /* -------------------------------------------------------------------------- */

  @Method()
  async printScreen() {
    if (!formStore.isScreenshotLoading && !commonStore.state.isPrintingScreen) {
      commonStore.state.isPrintingScreen = true;
      formStore.isScreenshotLoading = true;
      const html2canvas = (await import('html2canvas')).default;
      setTimeout(() => {
        html2canvas(document.body, {
          windowHeight: window.screen.height,
          height: window.innerHeight,
          y: window.scrollY,
          allowTaint: true,
          useCORS: true,
          foreignObjectRendering: true,
          ignoreElements: (element) => {
            return element.id === 'main-modal';
          },
        })
          .then((canvas) => {
            canvas.toBlob((blob) => {
              formStore.screenshot = new File(
                [blob],
                `screenshot_${
                  this.screenshotNumber === 1 ? 'automatic' : this.screenshotNumber - 1
                }.png`,
                {
                  type: blob.type,
                  lastModified: Date.now(),
                },
              );
              if (this.screenshotNumber === 1) {
                formStore.printScreen = canvas.toDataURL('image/png');
                formStore.hasScreenshot = true;
              }
              formStore.files?.push(formStore.screenshot);
              this.updateTotalFileSize();
              formStore.isScreenshotLoading = false;
              commonStore.state.isPrintingScreen = false;
              this.screenshotNumber++;
              forceUpdate(this);
            }, 'image/png');
          })
          .catch(() => {
            formStore.isScreenshotLoading = false;
            commonStore.state.isPrintingScreen = false;
          });
      });
    }
  }

  /* -------------------------------------------------------------------------- */
  /*                                RECORD SCREEN                               */
  /* -------------------------------------------------------------------------- */

  private shareScreen(): Promise<MediaStream> {
    let timerInterval;
    commonStore.state.recordingTime = 0;
    const mediaSupport = 'mediaDevices' in navigator;
    if (mediaSupport && null === this.cameraStream) {
      const mediaDevices = navigator.mediaDevices as {
        getDisplayMedia: (options: object) => Promise<MediaStream>;
      };
      return mediaDevices
        .getDisplayMedia({
          video: {
            cursor: 'always',
            mediaSource: 'screen',
            frameRate: 15,
          },
        })
        .then((mediaStreamObj) => {
          //add listeners for saving video/audio
          this.mediaRecorder = new MediaRecorder(mediaStreamObj);
          let chunks = [];

          document.addEventListener('startRecording', () => {
            this.mediaRecorder.start();
            timerInterval = setInterval(() => {
              commonStore.state.recordingTime++;
              if (commonStore.state.recordingTime >= 31) {
                this.stopStreaming();
              }
            }, 1000);
          });

          document.addEventListener('stopRecording', () => {
            if (this.mediaRecorder.state !== 'inactive') {
              this.mediaRecorder.stop();
            }
            clearInterval(timerInterval);
          });

          this.mediaRecorder.ondataavailable = (ev) => {
            chunks.push(ev.data);
          };

          this.mediaRecorder.onstop = () => {
            const blob = new Blob(chunks, { type: 'video/mp4' });
            chunks = [];
            formStore.recordedVideo = window.URL.createObjectURL(blob);
            formStore.recordedVideoFile = new File(
              [blob],
              `screen_recorded_${this.recordingNumber}.mp4`,
              {
                type: blob.type,
                lastModified: Date.now(),
              },
            );
            formStore.files?.push(formStore.recordedVideoFile);
            this.updateTotalFileSize();
            this.recordingNumber++;

            forceUpdate(this);

            // Stop sharing screen
            mediaStreamObj.getTracks().forEach((track) => {
              track.stop();
            });
            this.cameraStream = null;
          };
          return (this.cameraStream = mediaStreamObj);
        });
    } else {
      alert('Your browser does not support media devices.');
      commonStore.state.onRecording = false;
      commonStore.state.isRecording = false;
      this.cameraStream = null;
      return;
    }
  }

  private startStreaming() {
    if (!commonStore.state.isRecording) {
      commonStore.state.isRecording = true;
      this.shareScreen()
        .then((mediaStreamObj) => {
          this.videoStreamHTMLElement.srcObject = mediaStreamObj;
          this.videoStreamHTMLElement.onloadedmetadata = () => {
            this.videoStreamHTMLElement.play();
          };
          document.dispatchEvent(new CustomEvent('startRecording'));

          window.onbeforeunload = function () {
            return wcShared?.translate(
              'Votre ecran est en cours denregistrement, etes vous sur de vouloir quitter la page ?',
            );
          };
          commonStore.state.displayModal = false;
          commonStore.state.onRecording = true;
        })
        .catch(() => {
          commonStore.state.onRecording = false;
          commonStore.state.isRecording = false;
        });
    }
  }

  private stopStreaming() {
    document.dispatchEvent(new CustomEvent('stopRecording'));
    commonStore.state.displayModal = true;
    commonStore.state.onRecording = false;
    commonStore.state.isRecording = false;
    window.onbeforeunload = null;
  }

  /* -------------------------------------------------------------------------- */
  /*                                    FORM                                    */
  /* -------------------------------------------------------------------------- */

  private updateSubject = (event: Event, isFeedback = false): void => {
    const element = event.currentTarget as HTMLInputElement;
    const value = element.value;
    if (isFeedback) {
      formStore.subjectFeedback = value;
      return;
    }
    formStore.subject = value;
  };

  private updateCerberusLink = (event: Event): void => {
    const element = event.currentTarget as HTMLInputElement;
    formStore.cerberusLink = element.value;
  };

  private updateDescription = (event: Event, isFeedback = false): void => {
    const element = event.currentTarget as HTMLTextAreaElement;
    const value = element.value;
    if (isFeedback) {
      formStore.descriptionFeedback = value;
      return;
    }
    formStore.description = value;
  };

  private updateProject = (event?: Event): void => {
    const element = event?.currentTarget as HTMLSelectElement;
    const value = element?.value;
    if (event)
      formStore.project = formStore.projectsList.find(
        (project) => project.bucket_identifier === value,
      );
    formStore.typeBug = [];
    if (formStore.project?.actions['bugs']) {
      formStore.typeBug.push({
        label: wcShared?.translate('Bug'),
        value: 'bugs',
      });
    }
    if (formStore.project?.actions['features']) {
      formStore.typeBug.push({
        label: wcShared?.translate('Amelioration'),
        value: 'features',
      });
    }
    if (formStore.typeBug.length === 1) {
      formStore.type = formStore.typeBug[0].value;
    }
  };

  private updateType = (event: Event): void => {
    const element = event.currentTarget as HTMLSelectElement;
    formStore.type = element.value;
  };

  private updatePriority = (event: Event): void => {
    const element = event.currentTarget as HTMLSelectElement;
    formStore.bugPriorityValue = Number(element.value);
    formStore.bugPriorityLabel = formStore.bugPriorityList.find(
      (priority) => priority.value === Number(element.value),
    ).label;
  };
  private setDefaultPriority(): void {
    const value = '2';
    if (this.bugPriorityHTMLElement) this.bugPriorityHTMLElement.value = value;
    formStore.bugPriorityValue = Number(value);
    formStore.bugPriorityLabel = formStore.bugPriorityList.find(
      (priority) => priority.value === Number(value),
    ).label;
  }

  /* -------------------------------------------------------------------------- */
  /*                                UPLOAD FILES                                */
  /* -------------------------------------------------------------------------- */

  @Listen('paste')
  onPaste(e) {
    if (e.clipboardData.files.length) this.formatFiles.bind(this)(e);
  }

  private formatFiles(e) {
    e.preventDefault();
    this.dataFiles = e.dataTransfer || e.target.files || e.clipboardData.files;
    this.dataFiles = this.dataFiles['files'] || this.dataFiles;
    Object.keys(this.dataFiles).forEach((id) => {
      if (this.dataFiles[id].size <= 32000000) {
        const exist = formStore.files.find(
          (item) => item.name === this.dataFiles[id].name && item.size === this.dataFiles[id].size,
        );
        if (!Boolean(exist)) {
          formStore.files?.push(this.dataFiles[id]);
          this.updateTotalFileSize();
        }
      } else {
        this.arrayError?.push(this.dataFiles[id]);
        setTimeout(() => {
          this.arrayError.shift();
          forceUpdate(this);
        }, 3000);
      }
    });

    this.inputFile.value = '';

    forceUpdate(this);
  }

  private deleteFile(index: number): void {
    formStore.files.splice(index, 1);
    if (index === 0) {
      formStore.hasScreenshot = false;
    }
    this.updateTotalFileSize();
    forceUpdate(this);
  }

  private getMimeType(file: File): string {
    if (file.type.includes('application/pdf')) {
      return 'pdf';
    } else if (file.type.includes('text/plain')) {
      return 'text';
    } else if (file.type.includes('image/')) {
      return 'image';
    } else if (file.type.includes('video/')) {
      return 'video';
    } else {
      return 'default';
    }
  }

  private formatFileSize(fileSize: number): string {
    if (fileSize >= 1000000000) return Math.ceil(fileSize / 1000000000) + ' GB';
    if (fileSize >= 1000000) return Math.ceil(fileSize / 1000000) + ' MB';
    if (fileSize >= 1000) return Math.ceil(fileSize / 1000) + ' KB';
    return fileSize + ' B';
  }

  private updateTotalFileSize() {
    formStore.totalFileSize = formStore.files.reduce((acc, file) => {
      return acc + file.size;
    }, 0);
    formStore.jaugeWidth = Math.min(formStore.totalFileSize / 32000000, 1) * 130;
    if (formStore.jaugeWidth < 8 && formStore.jaugeWidth > 0) {
      formStore.jaugeWidth = 8;
    }
    const modules = document?.querySelectorAll('module-reporting-tools-component');
    modules.forEach((module) => {
      if (Boolean(module.shadowRoot?.querySelector('app-main-modal'))) {
        module.shadowRoot
          .querySelector('app-main-modal')
          .shadowRoot.getElementById('file-jauge').style.width = formStore.jaugeWidth + 'px';
      }
    });
  }

  private addFile = (event) => {
    event.preventDefault();
    this.dragOverFiles = false;
    this.inputFile.click();
  };

  private isFormComplete(): boolean {
    if (this.isFeedbackForm) {
      this.isFormValidFeedback = !(
        !Boolean(formStore.subjectFeedback) || !Boolean(formStore.descriptionFeedback)
      );
      return this.isFormValidFeedback;
    }

    if (
      !Boolean(formStore.project) ||
      !Boolean(formStore.project.bucket_identifier) ||
      !Boolean(formStore.subject) ||
      !Boolean(formStore.description) ||
      !Boolean(formStore.type) ||
      formStore.totalFileSize > 32000000
    ) {
      this.isFormValid = false;
      return false;
    }
    this.isFormValid = true;
    return true;
  }

  private checkFormAndSendReport = (isFeedback = false) => {
    this.isFeedbackForm = isFeedback;
    this.showResultSuccess = false;
    this.showResultError = false;
    if (this.isFormComplete()) {
      this.isLoading = true;
      if (this.isFeedbackForm) {
        formStore.subject = formStore.subjectFeedback;
        formStore.description = formStore.descriptionFeedback;
        formStore.type = 'features';
        formStore.files = [];
      }
      ReportService.sendReport(
        formStore.project.bucket_identifier,
        formStore.subject,
        formStore.description,
        formStore.cerberusLink,
        formStore.type,
        formStore.bugPriorityValue,
        formStore.bugPriorityLabel,
        formStore.files,
      )
        .then((result) => {
          this.ticketLink = result.data.url;
          this.showResultSuccess = true;
          this.isLoading = false;
          this.emitReportSubmitted.emit({ ticketUrl: result.data.url });
        })
        .catch(() => {
          this.showResultError = true;
          this.isLoading = false;
        });
    }
  };

  private displayPreview(index: number) {
    if (this.getMimeType(formStore.files[index]) === 'video') {
      setTimeout(() => {
        commonStore.state.displayVideoPreview = true;
      }, 50);
      commonStore.state.isImagePreview = false;
      formStore.recordedVideo = window.URL.createObjectURL(formStore.files[index]);
    }
    if (this.getMimeType(formStore.files[index]) === 'image') {
      setTimeout(() => {
        commonStore.state.displayVideoPreview = true;
      }, 50);
      commonStore.state.isImagePreview = true;
      formStore.printScreen = window.URL.createObjectURL(formStore.files[index]);
    }
  }

  private goToSupport = () => {
    this.hideModalAnimated();
    document.dispatchEvent(new CustomEvent('openSupportModule', { detail: { opening: 'chat' } }));
  };

  private isSuccessOrError() {
    return this.showResultSuccess || this.showResultError;
  }

  /* -------------------------------------------------------------------------- */
  /*                               Arrow Function                               */
  /* -------------------------------------------------------------------------- */

  private onDragFileOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.dragOverFiles = true;
  };

  private onDragFileDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.dragOverFiles = false;
    this.formatFiles.bind(this)(e);
  };

  private onDragFileLeave = () => (this.dragOverFiles = false);

  private onStopPropagation = (e) => e.stopPropagation();

  private onFeedBackFormToggled = () => {
    this.isFeedbackOpen = !this.isFeedbackOpen;
    this.isReportOpen = false;
  };

  private onReportFormToggled = () => {
    this.isReportOpen = !this.isReportOpen;
    this.isFeedbackOpen = false;
  };
  private onSubectInputFocus = () =>
    this.subjectTitleHTMLElement.classList.add(this.formTitleFocusClass);

  private onSubjectInputBlur = () => {
    if (!Boolean(formStore.subject?.length))
      this.subjectTitleHTMLElement.classList.remove(this.formTitleFocusClass);
  };

  private onToggleRecord = () => (commonStore.state.onRecording = !commonStore.state.onRecording);

  private oncheckFormAndSendReport = () => this.checkFormAndSendReport();

  private onUpdatingFeedBackSubject = (event) => this.updateSubject(event, true);
  private onFormSubjectFeedBackFocus = () =>
    this.subjectTitleFeedbackHTMLElement.classList.add(this.formTitleFocusClass);
  private onFormDescriptionFeedBackBlur = () =>
    !Boolean(formStore.descriptionFeedback?.length) &&
    this.descriptionTitleFeedackHTMLElement.classList.remove(this.formTitleFocusClass);

  private onFormSubjectFeedBackBlur = () =>
    !Boolean(formStore.subjectFeedback?.length) &&
    this.subjectTitleFeedbackHTMLElement.classList.remove(this.formTitleFocusClass);
  private onUpdateFeedBackDescription = (e) => this.updateDescription(e, true);

  private onCheckFormPassingTrue = () => this.checkFormAndSendReport(true);
  private onCheckFormPassingFeedback = () => this.checkFormAndSendReport(this.isFeedbackForm);
  private onDescriptionTextAreaFocus = () => {
    this.descriptionTitleHTMLElement.classList.add(this.formTitleFocusClass);
  };

  private onCerberusLinkInputFocus = () => {
    this.cerberusLinkTMLElement.classList.add(this.formTitleFocusClass);
  };

  private onCerberusLinkInputBlur = () => {
    if (!Boolean(formStore.cerberusLink?.length))
      this.cerberusLinkTMLElement.classList.remove(this.formTitleFocusClass);
  };

  private onDescriptionTextAreaBlur = () => {
    if (!Boolean(formStore.description?.length))
      this.descriptionTitleHTMLElement.classList.remove(this.formTitleFocusClass);
  };
  private onDescriptionFeedBackTextAreaFocus = () => {
    this.descriptionTitleFeedackHTMLElement.classList.add(this.formTitleFocusClass);
  };
  private onCloseReport = () => {
    if (formStore.isPartner) this.isReportOpen = false;
    else this.hideModalAnimated();
  };
  private onFormCancelClick = () => {
    this.isFeedbackOpen = false;
  };
  private onModaleCloseButtonClick = () => {
    this.hideModalAnimated();
    this.resetForm();
  };

  /* -------------------------------------------------------------------------- */
  /*                                    HTML                                    */
  /* -------------------------------------------------------------------------- */

  render() {
    return (
      <Host class={{ hide: this.hidden }}>
        <div
          class={{
            'background-overlay': true,
            hide: commonStore.state.onRecording,
          }}
          onClick={this.hideModalAnimated}
        ></div>
        <div
          // Here we need it to have parameter

          onClick={() => this.displayPreview(0)}
          class={{
            'capture-preview': true,
            hide: !formStore.hasScreenshot || formStore.files.length > 1,
          }}
        >
          <img
            height="150"
            src={formStore.printScreen}
          />
        </div>
        <div
          id="main-modal"
          class={{
            'main-modal': true,
            'main-modal__closing': this.modalIsClosing,
          }}
          onKeyUp={this.onStopPropagation}
          onKeyDown={this.onStopPropagation}
          onKeyPress={this.onStopPropagation}
          onDragOver={this.onDragFileOver}
          onDragLeave={this.onDragFileLeave}
          onDrop={this.onDragFileDrop}
        >
          {this.isInitLoading ? (
            <div class="main-modal__init-loader">
              <module-loader-component />
            </div>
          ) : (
            <Fragment>
              <div
                class={{
                  'drop-overlay': true,
                  'drop-overlay__active': this.dragOverFiles,
                }}
              >
                <img
                  height="250"
                  src={getAssetPath('./../assets/images/add-file.svg')}
                  alt={wcShared.translate('Fichiers')}
                />
              </div>
              <div
                class="main-modal__close"
                onClick={this.hideModalAnimated}
              >
                <img
                  src={getAssetPath('./../assets/images/cross.svg')}
                  alt={wcShared.translate('Fermer')}
                />
              </div>
              <div class={{ 'main-modal__title': true, hide: this.isSuccessOrError() }}>
                {wcShared?.translate('Que souhaitez-vous faire ?')}
              </div>

              <div
                class={{
                  'main-modal__content': true,
                  hide: this.isSuccessOrError(),
                }}
              >
                <div
                  class={{
                    header: true,
                    'no-margin': formStore.isPartner ? !this.isReportOpen : false,
                  }}
                  onClick={this.onReportFormToggled}
                >
                  <img
                    class="circle-icon"
                    src={getAssetPath('./../assets/images/computer-bug-white.svg')}
                    alt="Reporting-tools logo"
                  />
                  <div>
                    <div class="header__title">{wcShared?.translate('Signaler un bug')}</div>
                    <div class="header__description">
                      {wcShared?.translate(
                        'Les bugs avec nos services sont traites en priorite par nos developpeurs.',
                      )}
                    </div>
                  </div>
                  <img
                    class={{
                      // eslint-disable-next-line @typescript-eslint/naming-convention
                      header__chevron: true,
                      'report-open': formStore.isPartner ? this.isReportOpen : true,
                    }}
                    src={getAssetPath('./../assets/images/chevron-right-rt.svg')}
                    alt={wcShared.translate('Icon arrow')}
                  ></img>
                </div>
                <div
                  class={{
                    'report-content': true,
                    'report-open': formStore.isPartner ? this.isReportOpen : true,
                  }}
                >
                  {/*  ---------- FORM ----------  */}
                  <div class="form">
                    <div
                      class={{
                        'form-row': true,
                        hide: formStore.isPartner,
                      }}
                    >
                      {/*  ---------- FORM - PROJECT ----------  */}
                      <div class="form-project ik-form">
                        <div
                          class={'form-select__title ik-form__title ' + this.formTitleFocusClass}
                        >
                          {wcShared.translate('Projet concerne')}
                        </div>

                        <select
                          class="form-project__select ik-form__select"
                          onChange={this.updateProject}
                        >
                          <option
                            value=""
                            selected={!Boolean(formStore.project)}
                            disabled
                            hidden
                          >
                            {wcShared?.translate('Selectionner')}
                          </option>
                          {formStore.projectsList?.map((project) => {
                            return (
                              <option
                                selected={
                                  project?.bucket_identifier ===
                                  formStore.project?.bucket_identifier
                                }
                                value={project?.bucket_identifier}
                              >
                                {project?.title}
                              </option>
                            );
                          })}
                        </select>
                      </div>

                      {/*  ---------- FORM - TYPE ----------  */}
                      <div class="form-type ik-form">
                        <div
                          class={'form-select__title ik-form__title ' + this.formTitleFocusClass}
                        >
                          {wcShared.translate('Type')}
                        </div>

                        <select
                          class="form-type__select ik-form__select"
                          onChange={this.updateType}
                        >
                          <option
                            value=""
                            disabled
                            hidden
                          >
                            {wcShared?.translate('Selectionner')}
                          </option>
                          {formStore.typeBug?.map((reportType) => {
                            return (
                              <option
                                value={reportType?.value}
                                selected={reportType?.value === formStore.type}
                              >
                                {reportType?.label}
                              </option>
                            );
                          })}
                        </select>
                      </div>

                      {/*  ---------- FORM - PRIORITY ----------  */}
                      <div class="form-priority ik-form">
                        <div
                          class={'form-select__title ik-form__title ' + this.formTitleFocusClass}
                        >
                          {wcShared.translate('Priorite')}
                        </div>

                        <select
                          class="form-priority__select ik-form__select"
                          ref={(el) => (this.bugPriorityHTMLElement = el as HTMLSelectElement)}
                          onChange={this.updatePriority}
                        >
                          <option
                            value=""
                            selected
                            disabled
                            hidden
                          >
                            {wcShared.translate('Selectionner')}
                          </option>
                          {formStore.bugPriorityList?.map((priority) => {
                            return (
                              <option
                                value={priority?.value}
                                selected={formStore.bugPriorityValue === priority.value}
                              >
                                {priority?.label}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>

                    <div
                      class={{
                        'partner-box': true,
                        hide: !formStore.isPartner,
                      }}
                    >
                      <img
                        src={getAssetPath('./../assets/images/information.svg')}
                        alt={wcShared.translate('Information')}
                      />
                      <div class="partner-content">
                        {wcShared.translate(
                          'En tant que partenaire, vous pouvez nous signaler rapidement des bugs pour ameliorer votre experience. Merci pour votre temps.',
                        )}
                      </div>
                    </div>
                    {/*  ---------- FORM - SUBJECT ----------  */}
                    <div class="form-subject ik-form">
                      <div
                        class={{
                          'form-subject__title ik-form__title': true,
                          'ik-form__title--focus': formStore.subject?.length > 0,
                        }}
                        ref={(el) => (this.subjectTitleHTMLElement = el as HTMLElement)}
                      >
                        {wcShared.translate('Sujet')}
                      </div>
                      <input
                        class="form-subject__input ik-form__input"
                        id="form-subject"
                        onFocus={this.onSubectInputFocus}
                        onBlur={this.onSubjectInputBlur}
                        type="text"
                        onInput={this.updateSubject}
                        value={formStore.subject}
                        onKeyPress={(e) => this.onKeyPress(e)}
                        required
                        ref={(ref) => (this.subjectInputRef = ref)}
                      />
                    </div>

                    {/*  ---------- FORM - DESCRIPTION ----------  */}
                    <div class="form-description ik-form">
                      <div
                        class={{
                          'form-description__title ik-form__title ik-form__title--top': true,
                          'ik-form__title--focus': formStore.description?.length > 0,
                        }}
                        ref={(el) => (this.descriptionTitleHTMLElement = el as HTMLElement)}
                      >
                        {wcShared.translate('Description du probleme')}
                      </div>
                      <textarea
                        onKeyPress={(e) => this.onKeyPress(e)}
                        id="form-description"
                        class="form-description__textarea ik-form__textarea"
                        onFocus={this.onDescriptionTextAreaFocus}
                        onBlur={this.onDescriptionTextAreaBlur}
                        onInput={this.updateDescription}
                        value={formStore.description}
                      ></textarea>
                    </div>
                    {/*  ---------- FORM - LINK ----------  */}
                    {(this.user?.staff || this.isAutologged) && (
                      <div class="form-link ik-form">
                        <div
                          class={{
                            'form-link__title ik-form__title': true,
                            'ik-form__title--focus': formStore.cerberusLink?.length > 0,
                          }}
                          ref={(el) => (this.cerberusLinkTMLElement = el as HTMLElement)}
                        >
                          {wcShared.translate('Lien cerberus')}
                        </div>
                        <input
                          class="form-link__input ik-form__input"
                          id="form-link"
                          onFocus={this.onCerberusLinkInputFocus}
                          onBlur={this.onCerberusLinkInputBlur}
                          type="url"
                          onKeyPress={(e) => this.onKeyPress(e)}
                          onInput={this.updateCerberusLink}
                          value={formStore.cerberusLink}
                        />
                      </div>
                    )}

                    {/*  ---------- FORM - ACTIONS ----------  */}
                    <div class="form-actions">
                      <div class="form-actions__file tooltip">
                        <span class={{ tooltiptext: true }}>
                          {wcShared.translate('Joindre un fichier')}
                        </span>
                        <button onClick={this.addFile}>
                          <img
                            height="18"
                            src={getAssetPath('./../assets/images/attachment_2.svg')}
                            alt={wcShared.translate('Joindre un fichier')}
                          />
                        </button>
                      </div>
                      <div class="form-actions__record tooltip">
                        <span class={{ tooltiptext: true }}>
                          {wcShared.translate("Enregistrer l'ecran")}
                        </span>
                        <button onClick={this.onToggleRecord}>
                          <img
                            height="18"
                            src={getAssetPath('./../assets/images/icon-recording.png')}
                            alt={wcShared.translate('Enregistrer mon ecran')}
                          />
                        </button>
                      </div>
                      <div class="form-actions__screenshot tooltip">
                        <span class={{ tooltiptext: true }}>
                          {wcShared.translate("Capture d'ecran")}
                        </span>
                        <button onClick={() => this.printScreen()}>
                          <img
                            height="18"
                            class={{ hide: formStore.isScreenshotLoading }}
                            src={getAssetPath('./../assets/images/icon-screenshot.png')}
                            alt={wcShared.translate("Capture d'ecran")}
                          />
                          <img
                            class={{ hide: !formStore.isScreenshotLoading }}
                            height="18"
                            src={getAssetPath('./../assets/images/loader-ripple.svg')}
                            alt={wcShared.translate('chargement')}
                          />
                          <span
                            class={{
                              'screenshot-indicator': true,
                              hide: !formStore.isScreenshotLoading,
                            }}
                          >
                            {wcShared.translate('Enregistrement en cours')}
                          </span>
                        </button>
                      </div>
                    </div>

                    {/*  ---------- FORM - UPLOAD FILES ----------  */}
                    <div class="mail-product-files">
                      <div class="mail-product-files__title">{wcShared?.translate('Fichiers')}</div>
                      <div class="mail-product-files__description">
                        {wcShared?.translate(
                          "Nous avons pris une capture d'ecran automatique pour mieux comprendre votre message. Vous pouvez ajouter d'autres fichiers (32 MB maximum) ou la supprimer.",
                        )}
                      </div>
                      <div class="mail-product-files__description">
                        <div class="jauge__container">
                          <div
                            id="file-jauge"
                            class={{
                              'jauge__container--fill': true,
                              'jauge__container--fill--error': formStore.totalFileSize > 32000000,
                            }}
                          ></div>
                        </div>
                        {this.formatFileSize(formStore.totalFileSize)} / 32 MB
                        <div class={{ error: true, hide: formStore.totalFileSize <= 32000000 }}>
                          {wcShared?.translate('Vos fichiers sont trop volumineux')}
                        </div>
                      </div>
                      <div class="mail-product-files__files">
                        {Boolean(Object.keys(formStore.files)[0]) ? (
                          <div class="file-container">
                            {[
                              formStore.files.map((file, index) => {
                                return (
                                  <div class="file">
                                    <img
                                      // @TODO decide on a solution

                                      onClick={() => this.displayPreview(index)}
                                      src={getAssetPath(
                                        `./../assets/images/mimetype/${this.getMimeType(file)}.svg`,
                                      )}
                                      alt={wcShared.translate('Fichier')}
                                    />
                                    <div
                                      class={{
                                        // eslint-disable-next-line @typescript-eslint/naming-convention
                                        file__title: true,
                                        'file__title--clickable':
                                          this.getMimeType(file) === 'video' ||
                                          this.getMimeType(file) === 'image',
                                      }}
                                      onClick={() => this.displayPreview(index)}
                                    >
                                      {file.name}{' '}
                                      <span class="file__size">
                                        - {this.formatFileSize(file.size)}
                                      </span>
                                    </div>
                                    <div
                                      class="file__close"
                                      onClick={() => this.deleteFile(index)}
                                    >
                                      <img
                                        src={getAssetPath('./../assets/images/close-circle.png')}
                                        alt={wcShared.translate('Supprimer')}
                                      />
                                    </div>
                                  </div>
                                );
                              }),
                            ]}
                          </div>
                        ) : (
                          <div class="file-container">
                            <img
                              src={getAssetPath('./../assets/images/attachment_2.svg')}
                              alt={wcShared.translate('Icon attachment')}
                            />
                            <div class="file-text">
                              <a
                                href="#"
                                onClick={this.addFile}
                              >
                                {wcShared?.translate('Ajouter un fichier')}
                              </a>{' '}
                              {wcShared?.translate('ou faites glisser les fichiers ici')}
                            </div>
                          </div>
                        )}
                      </div>
                      {/* Error Files */}
                      <div class={{ error: true, hide: this.arrayError.length === 0 }}>
                        {this.arrayError.map((file) => {
                          return (
                            <div
                              class="error-file"
                              innerHTML={wcShared?.translate(
                                '<strong>$name$</strong> est trop volumineux',
                                {
                                  name: wcShared.store?.pipes?.escapeHtml(file.name),
                                },
                              )}
                            ></div>
                          );
                        })}
                      </div>
                    </div>
                    <input
                      class="hide"
                      ref={(el) => {
                        this.inputFile = el as HTMLInputElement;
                      }}
                      onChange={this.formatFiles.bind(this)}
                      type="file"
                      onKeyPress={(e) => this.onKeyPress(e)}
                      multiple
                      hidden
                    />
                  </div>

                  <video
                    class="hide"
                    ref={(el) => (this.videoStreamHTMLElement = el)}
                    controls
                  ></video>
                  <div class={{ 'error-message': true, hide: this.isFormValid }}>
                    {formStore.isPartner
                      ? wcShared?.translate(
                          'Veuillez au minimum selectionner un sujet et une description. Veillez aussi a ce que le poids total de vos pieces jointes ne depasse pas 32 MB.',
                        )
                      : wcShared?.translate(
                          'Veuillez au minimum selectionner un projet, un type de remontee et saisir un sujet et une description. Veillez aussi a ce que le poids total de vos pieces jointes ne depasse pas 32 MB.',
                        )}
                  </div>

                  <div class={{ 'main-modal__actions': true, hide: this.isSuccessOrError() }}>
                    <button
                      class="button-secondary"
                      onClick={this.onCloseReport}
                    >
                      {wcShared?.translate('Annuler')}
                    </button>
                    <button
                      class={{ primary: true, hide: this.isLoading }}
                      onClick={this.oncheckFormAndSendReport}
                    >
                      <span>{wcShared?.translate('Soumettre')}</span>
                    </button>
                    <img
                      class={{ hide: !this.isLoading }}
                      height="60"
                      width="100"
                      src={getAssetPath('./../assets/images/loader-ripple.svg')}
                      alt={wcShared.translate('chargement')}
                    />
                  </div>
                </div>
              </div>

              <div
                class={{
                  'main-modal__content': true,
                  hide: this.isSuccessOrError() || !formStore.isPartner,
                }}
              >
                <div
                  class={{ header: true, 'no-margin': !this.isFeedbackOpen }}
                  onClick={this.onFeedBackFormToggled}
                >
                  <img
                    class="circle-icon green"
                    src={getAssetPath('./../assets/images/light-shine.svg')}
                    alt="Feedbacks logo"
                  />
                  <div>
                    <div class="header__title">
                      {wcShared?.translate('Suggerer une amelioration ou une idee')}
                    </div>
                    <div class="header__description">
                      {wcShared?.translate(
                        'Votre idee sera discutee lors de la prochaine reunion hebdomadaire dediee au produit concerne.',
                      )}
                    </div>
                  </div>
                  <img
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    class={{ header__chevron: true, 'report-open': this.isFeedbackOpen }}
                    src={getAssetPath('./../assets/images/chevron-right-rt.svg')}
                    alt={wcShared.translate('Icon arrow')}
                  ></img>
                </div>
                <div class={{ 'report-content': true, 'report-open': this.isFeedbackOpen }}>
                  {/*  ---------- FORM ----------  */}
                  <div class="form">
                    {/*  ---------- FORM - FEEDBACK SUBJECT ----------  */}
                    <div class="form-subject ik-form">
                      <div
                        class={{
                          'form-subject__title ik-form__title': true,
                          'ik-form__title--focus': formStore.subjectFeedback?.length > 0,
                        }}
                        ref={(el) => (this.subjectTitleFeedbackHTMLElement = el as HTMLElement)}
                      >
                        {wcShared.translate('Idee')}
                      </div>
                      <input
                        class="form-subject__input ik-form__input"
                        id="form-subject-feedback"
                        onFocus={this.onFormSubjectFeedBackFocus}
                        onBlur={this.onFormSubjectFeedBackBlur}
                        onKeyPress={(e) => this.onKeyPress(e)}
                        type="text"
                        onInput={this.onUpdatingFeedBackSubject}
                        required
                      />
                    </div>

                    {/*  ---------- FORM - FEEDBACK DESCRIPTION ----------  */}
                    <div class="form-description ik-form">
                      <div
                        class={{
                          'form-description__title ik-form__title ik-form__title--top': true,
                          'ik-form__title--focus': formStore.descriptionFeedback?.length > 0,
                        }}
                        ref={(el) => (this.descriptionTitleFeedackHTMLElement = el as HTMLElement)}
                      >
                        {wcShared.translate('Description')}
                      </div>
                      <textarea
                        onKeyPress={(e) => this.onKeyPress(e)}
                        id="form-description-feedback"
                        class="form-description__textarea ik-form__textarea"
                        onFocus={this.onDescriptionFeedBackTextAreaFocus}
                        onBlur={this.onFormDescriptionFeedBackBlur}
                        onInput={this.onUpdateFeedBackDescription}
                        value={formStore.descriptionFeedback}
                      ></textarea>
                    </div>
                  </div>

                  <div class={{ 'error-message': true, hide: this.isFormValidFeedback }}>
                    {wcShared?.translate('Veuillez saisir votre idee et une description.')}
                  </div>

                  <div class={{ 'main-modal__actions': true, hide: this.isSuccessOrError() }}>
                    <button
                      class="button-secondary"
                      onClick={this.onFormCancelClick}
                    >
                      {wcShared?.translate('Annuler')}
                    </button>
                    <button
                      class={{ primary: true, hide: this.isLoading }}
                      onClick={this.onCheckFormPassingTrue}
                    >
                      <span>{wcShared?.translate('Soumettre')}</span>
                    </button>
                    <img
                      class={{ hide: !this.isLoading }}
                      height="60"
                      width="100"
                      src={getAssetPath('./../assets/images/loader-ripple.svg')}
                      alt={wcShared.translate('chargement')}
                    />
                  </div>
                </div>
              </div>

              <div
                class={{
                  'main-modal__content external-choice': true,
                  hide: this.isSuccessOrError() || !formStore.isPartner,
                }}
                onClick={this.goToSupport}
              >
                <div class="header">
                  <img
                    class="circle-icon blue"
                    src={getAssetPath('./../assets/images/support.svg')}
                    alt="Support logo"
                  />
                  <div>
                    <div class="header__title">
                      {wcShared?.translate('Contacter notre support')}
                    </div>
                    <div class="header__description">
                      {wcShared?.translate(
                        "Bloque ou besoin d'aide pour l'un de nos produits ? Veuillez contacter notre support.",
                      )}
                    </div>
                  </div>
                  <img
                    class="header__chevron"
                    src={getAssetPath('./../assets/images/chevron-right-rt.svg')}
                    alt={wcShared.translate('Icon arrow')}
                  ></img>
                  <img
                    class="header__chevron chevron-on-hover"
                    src={getAssetPath('./../assets/images/chevron-right-primary.svg')}
                    alt={wcShared.translate('Icon arrow')}
                  ></img>
                </div>
              </div>

              <div class={{ 'main-modal__actions--result': true, hide: !this.showResultSuccess }}>
                <img
                  class="result__image"
                  src={getAssetPath('./../assets/images/congrats.svg')}
                  alt={wcShared.translate('succes')}
                />
                {formStore.isPartner ? (
                  <div class="success-partner-message">
                    {wcShared?.translate(
                      "Votre avis est important et nous allons analyser avec attention votre contribution. Nous vous recontacterons uniquement si nous avons besoin d'informations supplementaires pour donner suite a votre message. Merci",
                    )}
                  </div>
                ) : (
                  <div>
                    <div>
                      {wcShared?.translate(
                        'Votre ticket a bien ete cree et un email de confirmation vous a ete envoye.',
                      )}
                    </div>
                    <div class={{ hide: !Boolean(this.ticketLink) }}>
                      {wcShared?.translate('Votre ticket est disponible ici:')}{' '}
                      <a
                        target="_blank"
                        href={this.ticketLink}
                      >
                        {this.ticketLink}
                      </a>
                    </div>
                  </div>
                )}
                <button
                  class="button__close button-secondary"
                  onClick={this.onModaleCloseButtonClick}
                >
                  {wcShared?.translate('Fermer')}
                </button>
              </div>
              <div class={{ 'main-modal__actions--result': true, hide: !this.showResultError }}>
                <img
                  height="100"
                  class="result__image"
                  src={getAssetPath('./../assets/images/error-call.svg')}
                  alt={wcShared.translate('erreur')}
                />
                <div class="error-message">
                  {' '}
                  {wcShared?.translate(
                    'Une erreur est survenue lors de la creation de votre ticket',
                  )}{' '}
                </div>
                <button
                  class="button__close primary"
                  onClick={this.onCheckFormPassingFeedback}
                >
                  {wcShared?.translate('Reessayer')}
                </button>
                <button
                  class="button__close button-secondary"
                  onClick={this.onModaleCloseButtonClick}
                >
                  {wcShared?.translate('Fermer')}
                </button>
              </div>
            </Fragment>
          )}
        </div>
      </Host>
    );
  }
}
